import React from "react";
import { FormattedMessage, Link, useIntl } from "gatsby-plugin-intl"

export default class MyForm extends React.Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      status: ""
    };
  }

  render() {
    const { status } = this.state;
    return (
      <form id="fs-frm"
        onSubmit={this.submitForm}
        action="https://formspree.io/f/xyybjwpy"
        method="POST"
      >
        {/* <!-- add your custom form HTML here --> */}
        <label for="full-name"><FormattedMessage id='contact_form_name' /> </label>
    <input type="text" name="name" id="full-name" ></input>
        <label>Email: </label>
        <input type="email"  name="email" />
        <label><FormattedMessage id='contat_form_message' /> </label>
        {/* <input type="text" name="message" /></p> */}
        <textarea rows="5" name="message" id="message" ></textarea>
        {status === "SUCCESS" ? <p>Obrigado!</p> : <button><FormattedMessage id='contact_form_submit' /></button>}
        {status === "ERROR" && <p>Desculpe! Houve algum erro.</p>}
      </form>
    );
  }

  submitForm(ev) {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }
}